import {
  Typography,
  Box,
  Autocomplete,
  TextField,
  Checkbox,
  ToggleButtonGroup,
  ToggleButton,
  Button,
} from "@mui/material";
import { StyledCreateInvoiceDataInput } from "./createInvoiceDataInput.styled";
import { Project } from "../../models/Project";
import { InvoiceCreateDto } from "../../models/dto/CreateInvoiceDto";
import { useProject } from "../../stores/useProject";
import { formatDate } from "../../globals/utils";
import { useEffect } from "react";

type CreateInvoiceDataInputProps = {
  invoiceData: Partial<InvoiceCreateDto & { project: Project | null }>;
  onChange: (
    val: Partial<InvoiceCreateDto & { project: Project | null }>
  ) => void;
  onClick: () => void;
};

export const CreateInvoiceDataInput = ({
  invoiceData,
  onChange,
  onClick,
}: CreateInvoiceDataInputProps) => {
  const { projects } = useProject();

  return (
    <StyledCreateInvoiceDataInput>
      <Typography variant="h1">Nieuwe Factuur maken</Typography>

      <Box className="selectProject">
        <Autocomplete
          options={projects || []}
          value={invoiceData.project}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          getOptionLabel={(option) =>
            option
              ? `${option.code} - ${option.contact?.address?.street ?? ""} ${
                  option.contact?.address?.number ?? ""
                } ${option.contact?.address?.city ?? ""}`
              : ""
          }
          onChange={(_, value) => onChange({ ...invoiceData, project: value })}
          renderInput={(params) => <TextField {...params} fullWidth required />}
        />
      </Box>

      <Box className="row">
        <Box className="column">
          <Typography variant="h4">Factuurdatum</Typography>
          <TextField
            type="date"
            fullWidth
            value={formatDate(invoiceData.invoiceDate)}
            onChange={(e) =>
              onChange({
                ...invoiceData,
                invoiceDate: new Date(e.target.value),
              })
            }
          />
        </Box>
        <Box className="column">
          <Typography variant="h4">Leverdatum</Typography>
          <TextField
            type="date"
            fullWidth
            value={formatDate(invoiceData.invoiceDeliveryDate)}
            onChange={(e) =>
              onChange({
                ...invoiceData,
                invoiceDeliveryDate: new Date(e.target.value),
              })
            }
          />
        </Box>
        <Box className="column">
          <Typography variant="h4">Vervaldatum</Typography>
          <Box className="row">
            <TextField
              type="date"
              fullWidth
              disabled={invoiceData.invoiceDueDate === "onmiddelijk te betalen"}
              value={formatDate(invoiceData.invoiceDueDate)}
              onChange={(e) => {
                onChange({
                  ...invoiceData,
                  invoiceDueDate: new Date(e.target.value),
                });
              }}
            />
          </Box>
        </Box>

        <Box className="column">
          <Typography variant="h4"></Typography>
          <Box className="checkWrapper">
            <Checkbox
              checked={invoiceData.invoiceDueDate === "onmiddelijk te betalen"}
              onChange={(e) => {
                const checked = e.target.checked;

                onChange({
                  ...invoiceData,
                  invoiceDueDate: checked
                    ? "onmiddelijk te betalen"
                    : new Date(),
                });
              }}
            />
            <Typography variant="h5">Onmiddellijk te betalen</Typography>
          </Box>
        </Box>
      </Box>

      <Box className="vatOptions">
        <ToggleButtonGroup
          exclusive
          value={invoiceData.vat}
          onChange={(_, value) => {
            onChange({ ...invoiceData, vat: value });
          }}>
          <ToggleButton value={0}>0%</ToggleButton>
          <ToggleButton value={6}>6%</ToggleButton>
          <ToggleButton value={21}>21%</ToggleButton>
        </ToggleButtonGroup>
      </Box>

      <Button className="submitBtn" onClick={onClick}>
        Verder
      </Button>
    </StyledCreateInvoiceDataInput>
  );
};
